import { Button } from "@/components/ui/button";
import { Pause, Play } from "lucide-react";
import React, { useEffect, useRef, useState } from "react";

export default function MicroPlayer({ source }) {
  const audioRef = useRef(new Audio());
  useEffect(() => {
    audioRef.current.src = source.masterUrl;
    setPlaying(false);
  }, [source]);
  const [playing, setPlaying] = useState(false);

  const playPause = () => {
    if (playing) {
      audioRef.current.pause();
      setPlaying(false);
    } else {
      audioRef.current.play();
      setPlaying(true);
    }
  };

  audioRef.current.onended = () => setPlaying(false);

  return (
    <div className="cursor-pointer">
      <Button
        className="play-button"
        onClick={playPause}
        variant="outline"
        size="sm"
      >
        {playing ? <Pause className="h-4 w-4" /> : <Play className="h-4 w-4" />}
      </Button>
    </div>
  );
}
